import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { LogoTypeEnum } from '~/component/logo/enums/logo-type.enum';
import { BreakpointWidthEnum } from '~/core/enums/breakpoint-width.enum';
import { SuccessStatusEnum } from '~/core/enums/success-status.enum';

@Component({
  selector: 'app-success-overlay',
  templateUrl: './success-overlay.component.html',
  styleUrls: ['./success-overlay.component.scss'],
})
export class SuccessOverlayComponent {
  @Input() public loadingDescription?: string;
  @Input() public loadingTitle?: string;
  @Input() public status = SuccessStatusEnum.SUCCESS;
  @Input() public successDescription: string;
  @Input() public successTitle: string;

  public readonly desktopBackgroundImage =
    'assets/success-v2/bg-success-desktop.svg';
  public readonly logoName = LogoTypeEnum.Regular;
  public readonly mdScreenSize = `(min-width:${BreakpointWidthEnum.MD}px)`;
  public readonly mobileBackgroundImage =
    'assets/success-v2/bg-success-mobile.svg';
  public readonly successImage = 'assets/success-v2/success.svg';
  public readonly successStatusEnum = SuccessStatusEnum;

  constructor(private readonly translateService: TranslateService) {}

  get description(): string {
    if (this.status === SuccessStatusEnum.LOADING) {
      return (
        this.loadingDescription ||
        this.translateService.instant('loading_screen.description')
      );
    }

    return this.successDescription;
  }

  get media(): string {
    return this.successImage;
  }

  get loadingStatus(): boolean {
    return this.status === SuccessStatusEnum.LOADING;
  }

  get title(): string {
    if (this.status === SuccessStatusEnum.LOADING) {
      return (
        this.loadingTitle ||
        this.translateService.instant('loading_screen.title')
      );
    }

    return this.successTitle;
  }
}
